import getCartAction from "./getCartAction";
import setCreditCardChargeRequest from "../requests/setCreditCardChargeRequest";

const getTotal = (grandTotal, charges) => {
    if(!grandTotal) return 0;

    const currentSurcharge = 0;
    console.log(charges);
    return grandTotal - currentSurcharge;
}

const getSurchargedCartAction = async (session, createNew, get, newChargeRate) => {

    const cart = await getCartAction(session, createNew);

    const currentChargeRate = get().getCreditCardChargeRate();

    const chargeRate = newChargeRate > -1 ? newChargeRate : currentChargeRate;
    const currentOrderTotal = getTotal(get().order.GrandTotal, get().charges);
    const total = getTotal(cart.order?.GrandTotal, cart?.charges);
    console.log({currentOrderTotal, currentChargeRate, total});
    if(currentChargeRate !== chargeRate || (currentOrderTotal !== total && chargeRate > 0)) {
        const overpayment = get().getOverpaymentForTotal(total);
        await setCreditCardChargeRequest(session, cart.order.id, chargeRate, overpayment);
        return await getCartAction(session, createNew);
    } else {
        return cart;
    }


}

export default getSurchargedCartAction;
